/**
 * TV kiosk mode — seeded from the ?tv=1 kiosk launch flag, persisted in
 * localStorage so it survives navigations and reloads.
 *
 * This MUST live in a leaf module that imports nothing from the app. ES module
 * evaluation runs a module's imports before its body, so when the seeding
 * lived in App.tsx, page modules (Watch, WatchYouTube, WatchExternal) that
 * snapshot IS_TV at their own module scope read localStorage BEFORE the
 * seeding ran. On a fresh/wiped Chromium profile that pinned the kiosk into
 * browser mode — in-browser <video> instead of mpv, autoplay blocked, cast
 * wedge guard disabled — until the next full reload. Importing the constant
 * from here guarantees the seed runs before ANY consumer's module body.
 */
function detectTvMode(): boolean {
  if (typeof window === "undefined") return false;
  if (new URLSearchParams(window.location.search).has("tv")) {
    localStorage.setItem("wallace_tv_mode", "1");
    return true;
  }
  return localStorage.getItem("wallace_tv_mode") === "1";
}

export const IS_TV = detectTvMode();
